import React from 'react';
import { useStatFeaturesQuery } from '@famly/stat_features_data';
import { toggleableFeatureAdapter } from './stat-togglable-feature-adapter';
/**
 * @deprecated We agreed on using the stat permissions together with the StatGuard instead.
 * @deprecated Use the stat context instead
 */
export function useStatFeatures(payload) {
    const { data, loading } = useStatFeaturesQuery({
        variables: {
            institutionSetId: payload.institutionId,
            siteSetId: payload.institutionId,
        },
        skip: payload.skip || !payload.institutionId,
    });
    return React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const { staffhours: { featureSettings: staffhoursFeatureSettings }, attendance: { featureSettings: attendanceFeatureSettings }, childProfile: careContractTemplatesFeatureSettings, featureSettings, } = data !== null && data !== void 0 ? data : {
            staffhours: { featureSettings: {} },
            attendance: { featureSettings: {} },
            childProfile: { featureSettings: {} },
            featureSettings: {},
        };
        const careRules = toggleableFeatureAdapter(featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.careRules);
        // Kept off the StatFeatures type on purpose: consumers must gate on the derived
        // `newRatioGraphs` instead, so removing this temporary flag later only touches this file.
        const staffRatioV2 = toggleableFeatureAdapter({
            canEnable: false,
            isEnabled: (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.staffRatioV2) === null || _a === void 0 ? void 0 : _a.isEnabled,
        });
        return [
            {
                staffHours: toggleableFeatureAdapter(staffhoursFeatureSettings.staffHours),
                leaveRange: toggleableFeatureAdapter(staffhoursFeatureSettings.leaveRangeSettings),
                staffSignInOut: toggleableFeatureAdapter(staffhoursFeatureSettings.employeeCheckIn),
                shiftPlanner: toggleableFeatureAdapter(staffhoursFeatureSettings.shiftplanner),
                attendancePage: toggleableFeatureAdapter(staffhoursFeatureSettings.staffAttendancePage),
                newStartersOnboarding: toggleableFeatureAdapter(attendanceFeatureSettings.newStarters),
                customFte: toggleableFeatureAdapter(attendanceFeatureSettings.customFte),
                milkReport: toggleableFeatureAdapter(attendanceFeatureSettings.milkReport),
                kinderConnect: toggleableFeatureAdapter(attendanceFeatureSettings.kinderConnect),
                customRegistrationForms: toggleableFeatureAdapter(attendanceFeatureSettings.customRegistrationForms),
                hideNewEnquiryButton: toggleableFeatureAdapter({
                    canEnable: false,
                    isEnabled: (_b = attendanceFeatureSettings.inquiry) === null || _b === void 0 ? void 0 : _b.hideNewEnquiryButton,
                }),
                hideInquiryCSVDownloadFeature: toggleableFeatureAdapter({
                    canEnable: false,
                    isEnabled: (_c = attendanceFeatureSettings.inquiry) === null || _c === void 0 ? void 0 : _c.hideEnquiryCSVDownload,
                }),
                careRequestsEnabled: toggleableFeatureAdapter({
                    canEnable: false,
                    isEnabled: (_d = attendanceFeatureSettings.inquiry) === null || _d === void 0 ? void 0 : _d.careRequestsEnabled,
                }),
                careRequestsEnabledForAnySite: toggleableFeatureAdapter({
                    canEnable: false,
                    isEnabled: (_e = attendanceFeatureSettings.inquiry) === null || _e === void 0 ? void 0 : _e.careRequestsEnabledForAnySite,
                }),
                heldPlacesEnabled: toggleableFeatureAdapter({
                    canEnable: false,
                    isEnabled: (_f = attendanceFeatureSettings.inquiry) === null || _f === void 0 ? void 0 : _f.heldPlacesEnabled,
                }),
                orgLevelOccupancyReport: toggleableFeatureAdapter(attendanceFeatureSettings.orgOccupancy),
                orgInquiries: toggleableFeatureAdapter(attendanceFeatureSettings.orgInquiries),
                staffLeaveV2: toggleableFeatureAdapter(staffhoursFeatureSettings.staffLeave),
                staffLeaveSources: toggleableFeatureAdapter(staffhoursFeatureSettings.staffLeaveSources),
                staffHoursApproval: toggleableFeatureAdapter(staffhoursFeatureSettings.approvalV2),
                taskManagement: toggleableFeatureAdapter(attendanceFeatureSettings.taskManagement),
                requireSubtypeToConfirmALeave: toggleableFeatureAdapter({
                    // This toggle should be visible only if the "STAFF_LEAVE" feature is enabled
                    canOptIn: (_h = (_g = staffhoursFeatureSettings.staffLeave) === null || _g === void 0 ? void 0 : _g.isEnabled) !== null && _h !== void 0 ? _h : false,
                    enabled: (_j = staffhoursFeatureSettings.subtype) === null || _j === void 0 ? void 0 : _j.required,
                }),
                restrictSubtypeSelection: toggleableFeatureAdapter({
                    // This toggle should be visible only if the "STAFF_LEAVE" feature is enabled
                    canOptIn: (_l = (_k = staffhoursFeatureSettings.staffLeave) === null || _k === void 0 ? void 0 : _k.isEnabled) !== null && _l !== void 0 ? _l : false,
                    enabled: (_m = staffhoursFeatureSettings.subtype) === null || _m === void 0 ? void 0 : _m.isRestricted,
                }),
                careContract: {
                    isEnabled: (_p = (_o = careContractTemplatesFeatureSettings === null || careContractTemplatesFeatureSettings === void 0 ? void 0 : careContractTemplatesFeatureSettings.careContractFeatureSettings) === null || _o === void 0 ? void 0 : _o.isEnabled) !== null && _p !== void 0 ? _p : false,
                },
                careContractNoSigneeRestrictions: (_r = (_q = careContractTemplatesFeatureSettings === null || careContractTemplatesFeatureSettings === void 0 ? void 0 : careContractTemplatesFeatureSettings.careContractFeatureSettings) === null || _q === void 0 ? void 0 : _q.noSigneeRestrictionsEnabled) !== null && _r !== void 0 ? _r : false,
                careRules,
                careSummary: toggleableFeatureAdapter({
                    canEnable: false,
                    isEnabled: (_s = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.careSummary) === null || _s === void 0 ? void 0 : _s.isEnabled,
                }),
                newRatioGraphs: toggleableFeatureAdapter({
                    canEnable: false,
                    isEnabled: careRules.isEnabled || staffRatioV2.isEnabled,
                }),
                contractedHoursPerDay: toggleableFeatureAdapter(staffhoursFeatureSettings.contractedHoursPerDay),
                staffBreakRules: toggleableFeatureAdapter(staffhoursFeatureSettings.staffBreakRules),
            },
            loading,
        ];
    }, [data, loading]);
}
